module.exports = __webpack_public_path__ + "static/img/102.239f45a3.png";